import React, { useState } from "react";

import { Typography } from "@mui/material";

import { CalendarPermissionLevel } from "@app/analytics/types";

import ConfirmationModal from "@rui/ConfirmationModal";
import Dropdown, { DropdownMenuItem } from "@rui/Dropdown";
import { getSelectedFromOptions } from "@rui/Dropdown/utils";
import Stack from "@rui/Stack";

import { WorkspaceSettingConfirmationModalProps } from "./types";
import { MEETING_ROLE, MEETING_TYPES } from "../../constants";

const JoinPreferences = ({
  workspaceSettings,
  ...props
}: WorkspaceSettingConfirmationModalProps) => {
  const [selectedRole, setSelectedRole] = useState(
    workspaceSettings.calendarPermissionLevel
  );
  const [selectedType, setSelectedType] = useState(
    workspaceSettings.calendarJoinInternalOnly
  );

  const handleConfirm = () => {
    props.onConfirm({ role: selectedRole, type: selectedType });
  };

  const handleClose = () => {
    setSelectedRole(workspaceSettings.calendarPermissionLevel);
    setSelectedType(workspaceSettings.calendarJoinInternalOnly);
    props.onClose();
  };

  return (
    <ConfirmationModal
      title="Read join preferences"
      {...props}
      size="md"
      onClose={handleClose}
      subtitle="Which meetings should Read Assistant automatically join?"
      onConfirm={handleConfirm}
    >
      <Stack spacing={2}>
        <Stack spacing={1}>
          <Typography variant="bodySecondaryReg">Meeting Role</Typography>
          <Dropdown
            name={MEETING_ROLE.name}
            sx={{ width: "100%" }}
            selectedItem={getSelectedFromOptions(
              MEETING_ROLE.options,
              selectedRole
            )}
            onChange={(e) =>
              setSelectedRole(e.target.value as CalendarPermissionLevel)
            }
          >
            {MEETING_ROLE.options.map((item) => {
              const isSelectedItem = item.value === selectedRole;
              return (
                <DropdownMenuItem
                  key={item.value}
                  {...item}
                  selected={isSelectedItem}
                />
              );
            })}
          </Dropdown>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="bodySecondaryReg">Meeting Types</Typography>
          <Dropdown
            selectedItem={getSelectedFromOptions(
              MEETING_TYPES.options,
              `${selectedType}`
            )}
            name={MEETING_TYPES.name}
            onChange={(e) => setSelectedType(e.target.value === "true")}
            sx={{ width: "600px", maxWidth: "100%" }}
          >
            {MEETING_TYPES.options.map((item) => {
              const isSelectedItem = item.value === `${selectedType}`;
              return (
                <DropdownMenuItem
                  key={item.value}
                  {...item}
                  selected={isSelectedItem}
                />
              );
            })}
          </Dropdown>
        </Stack>
      </Stack>
    </ConfirmationModal>
  );
};

export default JoinPreferences;
